import { createElement } from 'react';

import { cn } from '@/lib/utils/tailwind';

import { headingVariants } from './variants';

import type { HeadingProps } from './types';

export const Heading = ({
  variant = 'h1',
  as,
  ref,
  children,
  className,
  ...props
}: HeadingProps) => {
  const Tag = as || variant;
  return createElement(
    Tag,
    {
      className: cn(headingVariants({ variant }), className),
      ref,
      role: 'heading',
      'aria-label': props['aria-label'],
      ...props,
    },
    children,
  );
};
